<template>
  <div class="chat-container">
    <!-- 左侧导航栏 -->
    <nav class="nav-sidebar">
      <div class="nav-top">
        <div class="avatar">
          <img src="@/assets/logo.png" alt="avatar" class="avatar-img">
        </div>
        <div class="nav-item" :class="{ active: currentView === 'chat' }" @click="currentView = 'chat'">
          <i class="el-icon-chat-dot-round"></i>
          <span>消息</span>
        </div>
        <div class="nav-item" :class="{ active: currentView === 'bulk-send' }" @click="currentView = 'bulk-send'">
          <i class="el-icon-notebook-1"></i>
          <span>批量发送</span>
        </div>
        <div class="nav-item" :class="{ active: currentView === 'failed-log' }" @click="currentView = 'failed-log'">
          <i class="el-icon-warning"></i>
          <span>失败日志</span>
        </div>
        <div class="nav-item" @click="handleTestConnection">
          <i class="el-icon-connection"></i>
          <span>测试连接</span>
        </div>
        <div class="nav-item" @click="handleRefreshToken">
          <i class="el-icon-refresh"></i>
          <span>刷新令牌</span>
        </div>
        <div class="nav-item">
          <i class="el-icon-setting"></i>
          <span>设置</span>
        </div>
        <div class="nav-item" @click="showAbout">
          <i class="el-icon-info"></i>
          <span>关于</span>
        </div>
      </div>

      <div class="nav-bottom">
        <div class="nav-balance">
          <div class="status-label">余额</div>
          <div class="status-value">{{ balance }}条</div>
        </div>
        <div class="nav-item" @click="exit">
          <i class="el-icon-switch-button"></i>
          <span>退出</span>
        </div>
      </div>
    </nav>

    <!-- 中间聊天列表 -->
    <div class="chat-list">
      <!-- 添加框 -->
      <div class="search-box">
        <el-input
            placeholder="搜索联系人"
            prefix-icon="el-icon-search"
            v-model="searchText"
            clearable
            @input="handleSearch">
        </el-input>
        <el-button type="primary" icon="el-icon-plus" circle size="small" @click="handleAddContact"></el-button>
      </div>

      <!-- 当前号码提示 -->
      <div class="current-phone-hint">
        <i class="el-icon-mobile-phone"></i>
        <span>当前号码：<span class="phone-number">{{ phonenumber || '加载中...' }}</span></span>
      </div>

      <!-- 快捷联系人
      <div class="quick-contacts">
        <div class="contact-item" v-for="contact in quickContacts" :key="contact.id">
          <el-avatar :size="50" :src="contact.avatar">{{ contact.initial }}</el-avatar>
          <span class="contact-name">{{ contact.name }}</span>
        </div>
      </div> -->

      <!-- 修改过滤标签样式 -->
      <div class="filter-tags">
        <!-- 标签行 -->
        <div class="tag-row">
          <div :class="['tag-item', { active: activeTag === 'all' }]" @click="activeTag = 'all'">
            全部 {{ totalCount }}
          </div>
          <div :class="['tag-item', { active: activeTag === 'unread' }]" @click="activeTag = 'unread'">
            未读 {{ unreadCount }}
          </div>
          <div :class="['tag-item', { active: activeTag === 'unreplied' }]" @click="activeTag = 'unreplied'">
            未回复 {{ unrepliedCount }}
          </div>
          <div :class="['tag-item', { active: activeTag === 'replied' }]" @click="activeTag = 'replied'">
            已回复 {{ repliedCount }}
          </div>
        </div>

        <!-- 操作行 -->
        <div class="action-row">
          <template v-if="isEditing">
            <div class="tag-item checkbox-wrapper">
              <el-checkbox v-model="selectAll" @change="handleSelectAll">全选</el-checkbox>
            </div>
            <div class="tag-item danger" @click="handleDelete" :class="{ disabled: selectedChats.length === 0 }">
              <i class="el-icon-delete"></i> 删除({{ selectedChats.length }})
            </div>
            <div class="tag-item" @click="cancelEdit">
              <i class="el-icon-close"></i> 取消
            </div>
          </template>
        </div>
      </div>

      <!-- 聊天列表 -->
      <div class="chat-list-content">
        <div v-for="chat in filteredChats"
             :key="chat.id"
             :class="['chat-item', { 
               unreplied: chat.status === 'unreplied',
               'is-editing': isEditing
             }]"
             @click="isEditing ? null : handleChatClick(chat)">
          <el-checkbox
              v-if="isEditing"
              v-model="chat.selected"
              @change="handleSelect"
              class="chat-checkbox">
          </el-checkbox>
          <div class="avatar-wrapper">
            <el-avatar :size="40">
              {{ chat.otherPhone.slice(chat.otherPhone.length - 1, chat.otherPhone.length) }}
            </el-avatar>
            <span v-if="chat.unreadCount" class="unread-badge">{{ chat.unreadCount }}</span>
          </div>
          <div class="chat-info">
            <div class="chat-header">
              <span class="name">{{ chat.otherPhone }}</span>
              <span class="time">{{ chat.lastMessageTime }}</span>
            </div>
            <div class="last-message">{{ chat.lastMessage }}</div>
          </div>
          <span v-if="chat.type === 'group'" class="chat-type">群</span>
        </div>
      </div>

      <!-- 编辑按钮 -->
      <div class="edit-button" @click="startEdit" v-if="!isEditing">
        <i class="el-icon-edit"></i>
      </div>
    </div>

    <!-- 右侧主内容区域 -->
    <div class="main-content">
      <template v-if="currentView === 'chat'">
        <div class="welcome-page" v-if="!currentChat">
          <el-empty description="TT短信平台 欢迎您(^_^)">
          </el-empty>
        </div>
        <chat-window
            @query="queryContact"
            @send-success="me"
            v-else
            :chat="currentChat">
        </chat-window>
      </template>

      <template v-else-if="currentView === 'bulk-send'">
        <bulk-send-page/>
      </template>
      <template v-else-if="currentView === 'failed-log'">
        <failed-log-page/>
      </template>
    </div>

    <!-- 关于弹窗 -->
    <el-dialog
        title="关于 TT短信收发平台"
        :visible.sync="aboutDialogVisible"
        width="400px"
        center>
      <div class="about-content">
        <img src="@/assets/logo.png" alt="logo" class="about-logo">
        <h2>TT短信收发平台</h2>
        <p class="version">Version 1.5.0</p>
        <div class="description">
          一款简洁高效的短信收发平台
        </div>
        <div class="copyright">
          © 2024 TT短信收发平台. All rights reserved.
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import ChatWindow from '@/components/ChatWindow.vue'
import BulkSendPage from '@/components/BulkSendPage.vue'
import FailedLogPage from '@/components/FailedLogPage.vue'

export default {
  name: 'ChatHome',
  components: {
    ChatWindow,
    BulkSendPage,
    FailedLogPage
  },
  data() {
    return {
      loading: false,
      balance: 0,
      bulkSendVisible: false,
      currentView: 'chat',
      aboutDialogVisible: false,
      // ip: 'wss://sms.ttsmsgroup.com/prod-api',
      ip: 'wss://ttsms24.sbs/prod-api',
      // ip: 'ws://154.201.92.125:8879',
      // ip: 'ws://localhost:8878',
      phonenumber: null,
      searchText: '',
      activeTab: 'all',
      currentChat: null,
      totalCount: 0,
      unreadCount: 0,
      unrepliedCount: 0,
      repliedCount: 0,
      chats: [],
      filterTags: [
        {name: 'all', label: '全部', count: 16},
        {name: 'unread', label: '未读', count: 0}
      ],
      activeTag: 'all',
      isEditing: false,
      selectAll: false,
    }
  },
  computed: {
    filteredChats() {
      if (!Array.isArray(this.chats)) {
        return []
      }

      let chats = [...this.chats]

      // 搜索过滤
      if (this.searchText) {
        chats = chats.filter(chat =>
            chat.otherPhone.toLowerCase().includes(this.searchText.toLowerCase())
        )
      }

      // 标签过滤
      if (this.activeTag !== 'all') {
        switch (this.activeTag) {
          case 'unread':
            chats = chats.filter(chat => chat.unreadCount > 0)
            break
          case 'unreplied':
            chats = chats.filter(chat => chat.status === 'unreplied')
            break
          case 'replied':
            chats = chats.filter(chat => chat.status === 'replied')
            break
        }
      }
      return chats
    },
    totalUnreadCount() {
      return this.chats?.reduce((sum, chat) => sum + (chat.unreadCount || 0), 0)
    },
    selectedChats() {
      return this.chats.filter(chat => chat.selected)
    }
  },
  mounted() {
    this.me()
    this.queryContact()
  },
  methods: {
    me() {
      this.$http.post("/common/user/me")
          .then(res => {
            if (res.code == 200) {
              this.balance = res.data?.balance
              this.phonenumber = res.data?.phonenumber
              localStorage.setItem('me', JSON.stringify(res.data))
              this.connectWebSocket()
            } else {
              this.$message.error(res.msg)
              this.$router.push('/')
            }
          })
    },
    exit() {
      localStorage.removeItem('token')
      this.$router.push('/')
    },
    queryContact() {
      this.loading = true
      this.$http.post("/sms/info/queryChatList")
          .then(res => {
            this.chats = res.data?.chatList;
            this.unreadCount = res.data?.unreadCount;
            this.totalCount = res.data?.totalCount;
            this.unrepliedCount = res.data?.unrepliedCount;
            this.repliedCount = res.data?.repliedCount;
          }).finally(() => {
        this.loading = false
      })
    },
    handleAddContact() {
      if (!this.searchText) {
        this.$message.error('请输入联系人手机号')
        return
      }
      this.loading = true
      this.$http.post("/sms/info/addContact/" + this.searchText)
          .then(res => {
            if (res.code == 200) {
              this.searchText = '';
              this.queryContact()
              this.currentChat = res.data;
            } else {
              this.$message.error(res.msg)
            }
          }).finally(() => {
        this.loading = false
      })
    },
    handleTabClick(tab) {
      // 处理标签切换
    },
    connectWebSocket() {
      const wsUrl = `${this.ip}/smsWs?phoneNumber=${this.phonenumber}`; // 使用手机号作为查询参数
      this.ws = new WebSocket(wsUrl);

      this.ws.onopen = () => {
        console.log('WebSocket connection established');
        // 可以在这里发送一条初始化的消息
        this.sendMessage('Hello from ' + this.phonenumber);
      };

      this.ws.onmessage = (event) => {
        console.log('Received message:', event.data);
        this.queryContact()
        this.$bus.$emit('NEW_MESSAGE')
      };

      this.ws.onclose = () => {
        console.log('WebSocket connection closed');
      };

      this.ws.onerror = (error) => {
        console.error('WebSocket error:', error);
      };
    },

    sendMessage(message) {
      // 发送消息到 WebSocket
      if (this.ws && this.ws.readyState === WebSocket.OPEN) {
        this.ws.send(message);
      }
    },
    handleChatClick(chat) {
      this.currentChat = chat
      this.currentView = 'chat'  // 切换到聊天视图
    },
    showAbout() {
      this.aboutDialogVisible = true
    },
    startEdit() {
      this.isEditing = true
      this.chats.forEach(chat => {
        this.$set(chat, 'selected', false)
      })
    },
    cancelEdit() {
      this.isEditing = false
      this.selectAll = false
      this.chats.forEach(chat => {
        this.$set(chat, 'selected', false)
      })
    },
    handleSelectAll(val) {
      this.chats.forEach(chat => {
        this.$set(chat, 'selected', val)
      })
    },
    handleSelect() {
      this.selectAll = this.chats.every(chat => chat.selected)
    },
    handleDelete() {
      const phones = this.selectedChats.map(chat => chat.otherPhone)
      if (phones.length === 0) return

      this.$confirm('确认删除选中的联系人吗？', '提示', {
        type: 'warning'
      }).then(() => {
        this.$http.post(`/sms/info/removeContact/${phones.join(',')}`).then(res => {
          if (res.code === 200) {
            this.$message.success('删除成功')
            this.queryContact()
            this.cancelEdit()
          } else {
            this.$message.error(res.msg || '删除失败')
          }
        })
      }).catch(() => {
      })
    },
    handleSearch() {
      // 实时过滤,不需要额外处理,computed属性会自动更新
    },
    handleTestConnection() {
      this.$http.post("/sms/info/testUserConnection")
          .then(res => {
            if (res.code === 200) {
              this.$notify({
                title: '成功',
                message: '连接测试成功',
                type: 'success',
                position: 'bottom-right',
                duration: 2000
              });
            } else {
              this.$notify({
                title: '失败',
                message: res.msg || '连接测试失败',
                type: 'error',
                position: 'bottom-right',
                duration: 2000
              });
            }
          })
          .catch(err => {
            this.$notify({
              title: '失败',
              message: '连接测试失败',
              type: 'error',
              position: 'bottom-right',
              duration: 2000
            });
          });
    },
    handleRefreshToken() {
      this.$http.post("/sms/info/refreshUserToken")
          .then(res => {
            if (res.code === 200) {
              this.$notify({
                title: '成功',
                message: '令牌刷新成功',
                type: 'success',
                position: 'bottom-right',
                duration: 2000
              });
            } else {
              this.$notify({
                title: '失败',
                message: res.msg || '令牌刷新失败',
                type: 'error',
                position: 'bottom-right',
                duration: 2000
              });
            }
          })
          .catch(err => {
            this.$notify({
              title: '失败',
              message: '令牌刷新失败',
              type: 'error',
              position: 'bottom-right',
              duration: 2000
            });
          });
    },
  },
  watch: {
    totalUnreadCount(newCount) {
      this.filterTags = this.filterTags.map(tag => {
        if (tag.name === 'unread') {
          return {...tag, count: newCount}
        }
        return tag
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.chat-container {
  display: flex;
  height: 100vh;
  background: linear-gradient(135deg, #f6f8fc 0%, #eef1f8 100%);

  .nav-sidebar {
    width: 90px;
    background: linear-gradient(180deg, #7366ff 0%, #6157cc 100%);
    box-shadow: 0 0 20px rgba(115, 102, 255, 0.2);
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    padding: 24px 0;
    border-radius: 0 20px 20px 0;
    z-index: 10;

    .nav-top {
      display: flex;
      flex-direction: column;
      align-items: center;
    }

    .avatar {
      position: relative;
      width: 60px;
      height: 60px;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      padding: 5px;
      background: rgba(255, 255, 255, 0.2);
      border-radius: 50%;
      margin-bottom: 10px;
      box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);

      .avatar-img {
        width: 100%;
        height: 100%;
        border-radius: 50%;
        object-fit: contain;
        box-shadow: 0 4px 10px rgba(0, 0, 0, 0.15);
      }
    }

    .nav-item {
      display: flex;
      flex-direction: column;
      align-items: center;
      padding: 14px 0;
      cursor: pointer;
      width: 100%;
      color: rgba(255, 255, 255, 0.8);
      transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
      position: relative;

      i {
        font-size: 22px;
        margin-bottom: 5px;
        transition: all 0.3s;
      }

      span {
        font-size: 12px;
        transition: all 0.3s;
      }

      &:hover {
        background: rgba(255, 255, 255, 0.1);
        color: rgba(255, 255, 255, 1);
        transform: translateY(-2px);
      }

      &.active {
        color: #ffffff;
        background: rgba(255, 255, 255, 0.15);
        transform: translateY(-2px);

        &::after {
          content: '';
          position: absolute;
          right: 0;
          top: 50%;
          transform: translateY(-50%);
          width: 4px;
          height: 60%;
          background: #ffffff;
          border-radius: 4px 0 0 4px;
        }
      }
    }

    .nav-bottom {
      display: flex;
      flex-direction: column;
      align-items: center;
    }

    .nav-balance {
      width: 100%;
      padding: 10px 0;
      display: flex;
      flex-direction: column;
      align-items: center;
      margin-bottom: 10px;

      .status-label {
        font-size: 12px;
        color: rgba(255, 255, 255, 0.6);
      }

      .status-value {
        font-size: 16px;
        color: #ffffff;
        font-weight: 600;
      }
    }
  }

  .chat-list {
    width: 350px;
    display: flex;
    flex-direction: column;
    height: calc(100vh - 32px);
    background: white;
    box-shadow: 0 0 20px rgba(0, 0, 0, 0.05);
    z-index: 5;
    margin: 16px;
    margin-right: 0;
    border-radius: 20px;
    overflow: hidden;
    position: relative;

    .search-box {
      padding: 18px 16px;
      display: flex;
      gap: 10px;
      align-items: center;
      background: white;
      border-bottom: 1px solid rgba(0, 0, 0, 0.05);

      :deep(.el-button) {
        background: linear-gradient(135deg, #7366ff 0%, #a388ff 100%);
        border: none;
        box-shadow: 0 4px 10px rgba(115, 102, 255, 0.3);
        transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);

        &:hover {
          transform: translateY(-3px) scale(1.05);
          box-shadow: 0 6px 15px rgba(115, 102, 255, 0.4);
        }

        &:active {
          transform: translateY(0) scale(0.95);
        }
      }
    }

    :deep(.el-input) {
      flex: 1;
    }

    :deep(.el-input__inner) {
      border-radius: 20px;
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
      border: none;

      &:focus {
        box-shadow: 0 2px 12px rgba(115, 102, 255, 0.2);
      }
    }

    .current-phone-hint {
      padding: 12px 16px;
      border-bottom: 1px solid rgba(0, 0, 0, 0.05);
      background: white;
      display: flex;
      align-items: center;
      font-size: 13px;
      color: #4a5568;
      background: linear-gradient(to right, rgba(115, 102, 255, 0.05), rgba(255, 255, 255, 0));
      transition: all 0.3s;
      position: relative;
      overflow: hidden;

      &::before {
        content: '';
        position: absolute;
        left: 0;
        top: 0;
        height: 100%;
        width: 3px;
        background: linear-gradient(135deg, #7366ff 0%, #a388ff 100%);
      }

      &:hover {
        background: linear-gradient(to right, rgba(115, 102, 255, 0.08), rgba(255, 255, 255, 0));
      }

      i {
        margin-right: 8px;
        font-size: 16px;
        color: #7366ff;
        background: linear-gradient(135deg, #7366ff 0%, #a388ff 100%);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
      }

      span {
        font-weight: 500;

        .phone-number {
          color: #7366ff;
          font-weight: 600;
        }
      }
    }

    .filter-tags {
      padding: 5px 16px 10px 16px;
      border-bottom: 1px solid rgba(0, 0, 0, 0.05);
      background: white;

      .tag-row {
        padding-top: 10px;
        display: flex;
        align-items: center;
        flex-wrap: wrap;
        overflow-x: auto;
        margin-bottom: 10px;
        justify-content: space-between;
        gap: 8px;

        &::-webkit-scrollbar {
          display: none;
        }
      }

      .action-row {
        display: flex;
        align-items: center;
        justify-content: flex-end;
        gap: 10px;
        padding: 0 4px;
        position: relative;
      }

      .tag-item {
        height: 34px;
        width: 70px;
        padding: 0 14px;
        border-radius: 10px;
        background: #f8f9fa;
        font-size: 13px;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        color: #4a5568;
        transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
        border: none;
        white-space: nowrap;
        flex-shrink: 0;
        overflow: hidden;
        text-overflow: ellipsis;
        box-shadow: 0 2px 6px rgba(0, 0, 0, 0.05);
        position: relative;

        i {
          margin-right: 4px;
          font-size: 14px;
        }

        &.active {
          background: linear-gradient(135deg, #7366ff 0%, #a388ff 100%);
          color: white;
          box-shadow: 0 4px 10px rgba(115, 102, 255, 0.3);
          transform: translateY(-2px);
        }

        &:hover:not(.disabled) {
          background: linear-gradient(135deg, #7366ff 0%, #a388ff 100%);
          transform: translateY(-3px);
          color: white;
          box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
        }

        &.danger {
          &:hover:not(.disabled) {
            background: #fee2e2;
            color: #ef4444;
            transform: translateY(-3px);
          }
        }

        &.disabled {
          cursor: not-allowed;
          opacity: 0.6;
        }

        &::after {
          content: '';
          position: absolute;
          top: -2px;
          left: -2px;
          right: -2px;
          bottom: -2px;
          background: linear-gradient(135deg, #7366ff 0%, #a388ff 100%);
          border-radius: 12px;
          z-index: -1;
          opacity: 0;
          transition: all 0.3s;
        }

        &:hover::after {
          opacity: 0.2;
          transform: scale(1.05);
        }
      }

      .checkbox-wrapper {
        background: transparent;
        box-shadow: none;

        &:hover {
          background: transparent;
          transform: none;
          box-shadow: none;
        }
      }
    }

    .edit-button {
      position: absolute;
      right: 30px;
      bottom: 30px;
      width: 56px;
      height: 56px;
      background: linear-gradient(135deg, #7366ff 0%, #a388ff 100%);
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      box-shadow: 0 4px 20px rgba(115, 102, 255, 0.4);
      transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
      z-index: 100;
      border: 2px solid rgba(255, 255, 255, 0.2);

      &::before {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: linear-gradient(135deg, rgba(255, 255, 255, 0.1) 0%, rgba(255, 255, 255, 0) 100%);
        border-radius: 50%;
        z-index: -1;
      }

      i {
        font-size: 26px;
        color: white;
        text-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
      }

      &:hover {
        transform: translateY(-4px) scale(1.05);
        box-shadow: 0 8px 25px rgba(115, 102, 255, 0.5);
        border-color: rgba(255, 255, 255, 0.3);
      }

      &:active {
        transform: translateY(0) scale(0.95);
        box-shadow: 0 4px 15px rgba(115, 102, 255, 0.3);
      }

      &::after {
        content: '';
        position: absolute;
        top: -2px;
        left: -2px;
        right: -2px;
        bottom: -2px;
        background: linear-gradient(135deg, #7366ff 0%, #a388ff 100%);
        border-radius: 50%;
        z-index: -2;
        opacity: 0;
        transition: all 0.3s;
      }

      &:hover::after {
        opacity: 0.5;
        transform: scale(1.1);
      }
    }

    .chat-list-content {
      flex: 1;
      overflow-y: auto;
      overflow-x: hidden;
      padding: 10px;
      position: relative;

      .chat-item {
        padding: 16px;
        display: flex;
        align-items: center;
        gap: 14px;
        position: relative;
        transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
        cursor: pointer;
        border-radius: 16px;
        margin-bottom: 10px;
        background: white;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);

        &:hover {
          transform: translateY(-3px) translateX(2px);
          box-shadow: 0 8px 16px rgba(0, 0, 0, 0.1);
        }

        .avatar-wrapper {
          position: relative;

          :deep(.el-avatar) {
            background: linear-gradient(135deg, #7366ff 0%, #a388ff 100%);
            box-shadow: 0 4px 10px rgba(115, 102, 255, 0.3);
            transition: all 0.3s;

            &:hover {
              transform: scale(1.05);
              box-shadow: 0 6px 15px rgba(115, 102, 255, 0.4);
            }
          }

          .unread-badge {
            position: absolute;
            top: -6px;
            right: -6px;
            min-width: 18px;
            height: 18px;
            padding: 0 6px;
            background: linear-gradient(135deg, #fd3c97 0%, #f97794 100%);
            color: white;
            border-radius: 9px;
            font-size: 12px;
            display: flex;
            align-items: center;
            justify-content: center;
            box-shadow: 0 2px 5px rgba(253, 60, 151, 0.4);
            transition: all 0.3s;

            &:hover {
              transform: scale(1.1);
              box-shadow: 0 4px 8px rgba(253, 60, 151, 0.5);
            }
          }
        }

        .chat-info {
          flex: 1;

          .chat-header {
            display: flex;
            justify-content: space-between;
            margin-bottom: 6px;
            align-items: center;

            .name {
              font-weight: 600;
              color: #1e293b;
            }

            .time {
              font-size: 12px;
              color: #64748b;
            }
          }

          .last-message {
            font-size: 13px;
            color: #64748b;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            max-width: 220px;
          }
        }

        .chat-type {
          position: absolute;
          top: 12px;
          right: 12px;
          font-size: 12px;
          padding: 2px 8px;
          background: #e9ecef;
          border-radius: 8px;
          color: #4a5568;
        }

        &.is-editing {
          padding-left: 46px;
          position: relative;

          .chat-checkbox {
            position: absolute;
            left: 16px;
            top: 50%;
            transform: translateY(-50%);
          }
        }
      }
    }
  }

  .main-content {
    flex: 1;
    display: flex;
    background: linear-gradient(135deg, #f1f4f9 0%, #eaedfa 100%);
    position: relative;

    .welcome-page {
      flex: 1;
      display: flex;
      justify-content: center;
      align-items: center;
      background: rgba(255, 255, 255, 0.7);
      margin: 16px;
      border-radius: 20px;
      box-shadow: 0 8px 30px rgba(0, 0, 0, 0.05);

      :deep(.el-empty) {
        .el-empty__image {
          width: 160px;
        }

        .el-empty__description {
          color: #7366ff;
          font-weight: 500;
          font-size: 16px;
          margin-top: 20px;
        }
      }
    }
  }
}

.chat-item.unreplied {
  background: linear-gradient(to right, rgba(254, 215, 226, 0.7), white 15%);
  border-left: 3px solid #fd3c97;
}

.nav-item {
  &.active {
    color: #ffffff;
  }
}

.about-content {
  text-align: center;
  padding: 30px 0;

  .about-logo {
    width: 100px;
    height: 100px;
    margin-bottom: 20px;
    filter: drop-shadow(0 4px 8px rgba(0, 0, 0, 0.1));
  }

  h2 {
    font-size: 24px;
    color: #1e293b;
    margin: 0 0 8px;
    font-weight: 600;
  }

  .version {
    font-size: 14px;
    color: #64748b;
    margin: 0 0 20px;
  }

  .description {
    font-size: 14px;
    color: #334155;
    margin-bottom: 30px;
    line-height: 1.6;
  }

  .copyright {
    font-size: 12px;
    color: #94a3b8;
  }
}

:deep(.el-dialog) {
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0 20px 50px rgba(0, 0, 0, 0.1);

  .el-dialog__header {
    background: linear-gradient(135deg, #7366ff 0%, #a388ff 100%);
    padding: 16px 20px;

    .el-dialog__title {
      color: white;
      font-weight: 500;
    }

    .el-dialog__headerbtn {
      .el-dialog__close {
        color: rgba(255, 255, 255, 0.9);
      }
    }
  }

  .el-dialog__body {
    padding: 30px;
  }
}
</style>